import "core-js/modules/es6.string.small";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.small";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import styled from 'styled-components';
import Color from 'color';
import { rgba } from 'polished';
import { color, spacing } from '../style/theme';

var getColor = function getColor(_ref) {
  var overideTextColor = _ref.overideTextColor,
      invert = _ref.invert,
      theme = _ref.theme;
  return overideTextColor && color[overideTextColor] || invert && (color[theme] || color.secondary1) || '#fff';
};

var getBorderColor = function getBorderColor(_ref2) {
  var theme = _ref2.theme;
  return theme && color[theme] || color.secondary1;
};

var getBgColor = function getBgColor(_ref3) {
  var invert = _ref3.invert,
      theme = _ref3.theme;
  return invert && '#fff' || getBorderColor({
    theme: theme
  });
};
/**
 * Remove 2px from the vertical padding to allow the button to
 * match our vertical rhythmn.
 * This is due to the 1px border adding to the height.
 */


var getPadding = function getPadding(_ref4) {
  var small = _ref4.small,
      wide = _ref4.wide;
  var verticalPadding = spacing.halve;
  var horizontalPadding = spacing.base;

  if (small) {
    verticalPadding = verticalPadding / 2;
    horizontalPadding = horizontalPadding / 2;
  }

  if (wide) {
    horizontalPadding = horizontalPadding * 2;
  }

  return verticalPadding - 1 + "px " + horizontalPadding + "px";
};
/**
 * If we pass our own custom props down to Link, it causes prop errors to occur in the console
 * Below, we explicitly list our custom props and use the spread operator to pass the rest to Link
 */


var Button = styled(function (_ref) {
  var submit = _ref.submit,
      small = _ref.small,
      wide = _ref.wide,
      overideTextColor = _ref.overideTextColor,
      invert = _ref.invert,
      theme = _ref.theme,
      fullWidth = _ref.fullWidth,
      shadow = _ref.shadow,
      Link = _ref.Link,
      props = _objectWithoutProperties(_ref, ["submit", "small", "wide", "overideTextColor", "invert", "theme", "fullWidth", "shadow", "Link"]);

  return submit && React.createElement("button", _extends({
    type: "submit"
  }, props)) || Link(props);
}).withConfig({
  displayName: "Button",
  componentId: "sc-1aj9erv-0"
})(["box-shadow:", ";width:", ";text-align:", ";border-radius:3px;border-style:solid;border-width:1px;cursor:pointer;padding:", ";background-color:", ";border-color:", ";color:", ";font-size:", ";display:inline-block;text-decoration:none;&[disabled]{cursor:not-allowed;background-color:", ";color:", ";border-color:", ";}&:hover{background-color:", ";border-color:", ";}"], function (props) {
  return props.shadow ? "0px 0px 20px 0px " + rgba(getBgColor(props), 0.5) + ";" : '';
}, function (_ref5) {
  var fullWidth = _ref5.fullWidth;
  return fullWidth ? '100%' : null;
}, function (_ref6) {
  var fullWidth = _ref6.fullWidth;
  return fullWidth ? 'center' : null;
}, function (props) {
  return getPadding(props);
}, function (props) {
  return getBgColor(props);
}, function (props) {
  return getBorderColor(props);
}, function (props) {
  return getColor(props);
}, function (_ref7) {
  var small = _ref7.small;
  return small ? '1.4rem' : null;
}, function (_ref8) {
  var invert = _ref8.invert;
  return invert ? '#fff' : color.secondary6;
}, function (_ref9) {
  var invert = _ref9.invert;
  return invert ? color.secondary6 : '#fff';
}, color.secondary6, function (props) {
  return Color(getBgColor(props)).darken(0.2).hsl().string();
}, function (props) {
  return Color(getBorderColor(props)).darken(0.2).hsl().string();
});
export default Button;